import React from 'react'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'
import { withRouter } from 'react-router-dom'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'

import ControlledModal from 'components/Modal/ControlledModal'
import FinancingApplicationEdit from 'components/Financing/FinancingApplication/FinancingApplicationEdit/FinancingApplicationEdit'

import './financing-application-edit-modal.pcss'

const FinancingApplicationEditModal = ({ t, match }) => {
    return (
        <ControlledModal
            routedModal
            name="financing-application-edit-modal"
            context="financingApplicationEditModal"
            initialTitle={t('financing:application.editApplication')}
            okButtonTxt={t('common:close')}
            okButtonClasses="button--tertiary"
            requireUserInput={false}
            closeOnRouteChange={false}
        >
            <FinancingApplicationEdit financingApplicationId={match.params.financingApplicationId} />
        </ControlledModal>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
    withTranslationCustom(['common', 'financing'])
)(FinancingApplicationEditModal)
